import moment from 'moment-timezone'

// Checks if object is empty: {}
export const isEmpty = (object) =>
    Object.keys(object).filter(item => { return object[item]; }).length === 0;

export const makeDates = (set) => {
    return set.map((bm) => {
        return {
            graphType: bm.graphType,
            data: bm.data.map((d) => ({
                ...d,
                date: new Date(d.date),
            })),
            verticalGridLines: bm.verticalGridLines.map((date) => (new Date(date))),
            minDate: new Date(bm.minDate),
            maxDate: new Date(bm.maxDate),
            clippingPoint: bm.clippingPoint ? new Date(bm.clippingPoint) : null,
            unit: bm.unit,
            ranges: bm.ranges,
        };
    });
};

export const addDaysToEndOfToday = (days) => {
    return moment().endOf('day').add(days, 'days').toDate();
}

export const capitaliseWord = (word) => {
  return word[0].toUpperCase() + word.slice(1);
}
